/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ControlRound': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 14',
    data: '<path pid="0" _fill="none" _stroke="#cfcfcf" stroke-width="1.5" d="M7 .75a6.23 6.23 0 00-4.42 1.83A6.23 6.23 0 00.75 7c0 1.726.7 3.288 1.83 4.42A6.23 6.23 0 007 13.25a6.23 6.23 0 004.42-1.83A6.23 6.23 0 0013.25 7a6.23 6.23 0 00-1.83-4.42A6.23 6.23 0 007 .75z"/>'
  }
})
